export const FETCH_TATAPPROACHING_REQUEST = "FETCH_TATAPPROACHING_REQUEST";
export const FETCH_TATAPPROACHING_SUCCESS = "FETCH_TATAPPROACHING_SUCCESS";
export const FETCH_TATAPPROACHING_FAILURE = "FETCH_TATAPPROACHING_FAILURE";

